document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
  initOceanoProfundidad();
  initPuntosCarga();
  initCuentaAtras();
});

function initCuentaAtras() {
  var contenedor = document.querySelector('[data-mt-cuenta-atras]');
  if (!contenedor) return;

  var elDias = contenedor.querySelector('[data-mt-dias]');
  var elHoras = contenedor.querySelector('[data-mt-horas]');
  var elMinutos = contenedor.querySelector('[data-mt-minutos]');
  var elSegundos = contenedor.querySelector('[data-mt-segundos]');

  function proximoViernes() {
    var ahora = new Date();
    var objetivo = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 23, 59, 59, 0);
    var diasHasta = (5 - ahora.getDay() + 7) % 7;
    objetivo.setDate(objetivo.getDate() + diasHasta);
    if (objetivo <= ahora) {
      objetivo.setDate(objetivo.getDate() + 7);
    }
    return objetivo;
  }

  function dosDigitos(n) {
    return String(n).padStart(2, '0');
  }

  function actualizar() {
    var ahora = new Date();
    var restante = proximoViernes() - ahora;
    if (restante < 0) restante = 0;

    var dias = Math.floor(restante / (1000 * 60 * 60 * 24));
    var horas = Math.floor((restante / (1000 * 60 * 60)) % 24);
    var minutos = Math.floor((restante / (1000 * 60)) % 60);
    var segundos = Math.floor((restante / 1000) % 60);

    if (elDias) elDias.textContent = dosDigitos(dias);
    if (elHoras) elHoras.textContent = dosDigitos(horas);
    if (elMinutos) elMinutos.textContent = dosDigitos(minutos);
    if (elSegundos) elSegundos.textContent = dosDigitos(segundos);
  }

  actualizar();
  setInterval(actualizar, 1000);
}

function initPuntosCarga() {
  if (!document.body.classList.contains('password')) return;
  var heading = document.querySelector('.email-signup-banner__heading');
  if (!heading) return;
  var puntos = document.createElement('span');
  puntos.className = 'mt-puntos-carga';
  puntos.innerHTML = '<span>.</span><span>.</span><span>.</span>';
  heading.appendChild(puntos);
}

function initOceanoProfundidad() {
  var oceano = document.querySelector('[data-mt-oceano]');
  if (!oceano) return;

  var ticking = false;

  function actualizar() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    var progreso = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    progreso = Math.min(Math.max(progreso, 0), 1);
    oceano.style.backgroundPositionY = (progreso * 100) + '%';
    ticking = false;
  }

  function solicitar() {
    if (!ticking) {
      requestAnimationFrame(actualizar);
      ticking = true;
    }
  }

  actualizar();
  window.addEventListener('scroll', solicitar, { passive: true });
  window.addEventListener('resize', solicitar);
}

function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('[data-galeria-miniatura]');
  if (!miniaturas.length) return;
  var imagenes = document.querySelectorAll('[data-galeria-imagen]');

  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var indice = btn.getAttribute('data-galeria-miniatura');
      imagenes.forEach(function (img) {
        img.classList.toggle('mt-galeria-activa', img.getAttribute('data-galeria-imagen') === indice);
      });
      miniaturas.forEach(function (m) {
        m.classList.toggle('mt-miniatura-activa', m === btn);
      });
    });
  });
}

function initVariantesProducto() {
  var selects = document.querySelectorAll('.mt-opcion-select');
  if (!selects.length) return;

  var seccion = selects[0].closest('.mt-producto');
  if (!seccion) return;

  var scriptVariantes = seccion.querySelector('[data-variantes-producto]');
  var variantes = scriptVariantes ? JSON.parse(scriptVariantes.textContent) : [];
  var inputVariante = seccion.querySelector('[data-variante-input]');
  var botonComprar = seccion.querySelector('[data-boton-comprar]');
  var botonTexto = seccion.querySelector('[data-boton-texto]');
  var precioActual = seccion.querySelector('[data-precio-actual]');
  var precioComparado = seccion.querySelector('[data-precio-comparado]');
  var badgeDescuento = seccion.querySelector('[data-badge-descuento]');

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;

    inputVariante.value = variante.id;

    if (precioActual) precioActual.textContent = formatearDinero(variante.price);
    var hayDescuento = variante.compare_at_price && variante.compare_at_price > variante.price;
    if (precioComparado) {
      if (hayDescuento) {
        precioComparado.style.display = '';
        precioComparado.textContent = formatearDinero(variante.compare_at_price);
      } else {
        precioComparado.style.display = 'none';
      }
    }
    if (badgeDescuento) {
      if (hayDescuento) {
        var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
        badgeDescuento.style.display = '';
        badgeDescuento.textContent = '-' + pct + '% descuento';
      } else {
        badgeDescuento.style.display = 'none';
      }
    }

    if (botonComprar) {
      botonComprar.disabled = !variante.available;
    }
    if (botonTexto) {
      botonTexto.textContent = variante.available
        ? (botonComprar.dataset.textoDisponible || botonTexto.textContent)
        : (botonComprar.dataset.textoAgotado || 'Agotado');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function formatearDinero(centavos) {
  return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el) {
    if (el.classList.contains('mt-reveal-stagger')) {
      Array.prototype.forEach.call(el.children, function (child, i) {
        child.style.setProperty('--mt-i', i);
      });
    }
    observer.observe(el);
  });
}

function initCifras() {
  var cifras = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!cifras.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var hasta = parseFloat(el.dataset.hasta) || 0;
      var sufijo = el.dataset.sufijo || '';
      observer.unobserve(el);

      if (prefersReduced) {
        el.textContent = hasta + sufijo;
        return;
      }

      var inicio = null;
      var duracion = 1400;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * hasta);
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });

  cifras.forEach(function (el) { observer.observe(el); });
}
